import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class LoadingService {

	private loadingElement: HTMLIonLoadingElement | null = null;
	
	private readonly loadingDelay: number = 250;
	private loadingTimeout: ReturnType<typeof setTimeout> | null = null;

	constructor(
		private controller: LoadingController,
		private translate: TranslateService,
	) {
	}

	public async start(message: string = null) {
		if (!message) {
			message = this.translate.instant('LOADING.MSG');
		}

		//! Metto un cablone temporaneo mentre cerco di capire come caricare le label PRIMA di questo
		if (message == 'LOADING.MSG') {
			message = 'Loading...';
		}

		this.loadingElement = await this.controller.create({
			message: message,
			duration: -1,
		});
		this.loadingTimeout = setTimeout(() => {
			this.loadingTimeout = null;
			this.loadingElement?.present();
		}, this.loadingDelay);
	}

	public async stop() {
		if (this.loadingTimeout) {
			clearTimeout(this.loadingTimeout);
			this.loadingTimeout = null;
		}
		await this.loadingElement?.dismiss();
	}
}
